import React from "react";
import { Spinner } from "@fluentui/react-components";
import { Page } from "./Page";
import { useQuery } from "@apollo/client/react";
import { GET_ABOUTSECTION } from "../graphql/queries";
import { AboutUs } from "../components/about/AboutUs";
import { HeroAbout } from "../components/about/HeroAbout";
import { Error } from "./Error";
import { useCmsLocale } from "../i18n/cmsLocale";

export const About = () => {
  const locale = useCmsLocale();
  const { data, loading, error } = useQuery(GET_ABOUTSECTION, { variables: { locale } });
  if (loading) return <Spinner style={{ marginTop: "30vh" }} size="huge" />;
  if (error || !data.aboutSection)
    return <Error error={error ? error.message : "aboutSection"} />;

  return (
    <Page>
      <HeroAbout data={data} />
      <AboutUs data={data} />
    </Page>
  );
};
